import * as React from 'react';
const DialogContext = /*#__PURE__*/React.createContext({});
if (process.env.NODE_ENV !== 'production') {
  DialogContext.displayName = 'DialogContext';
}
export default DialogContext;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Dialog/DialogContext.js
// module id = 841
// module chunks = 22